// extracted by mini-css-extract-plugin
export var icon = "_63-1";
export var subtext = "_63-0";